<template>
    <div class="carousel-container mt-4 pb-md-8" v-if="listing.galleryImages && listing.galleryImages.length > 0">
        <FsLightbox v-if="lightboxGallery.length > 0"
            :toggler="lightbox"
            :sources="lightboxGallery"
            :slide="lightboxSlide"
            type="image"
        />

        <v-carousel
            v-model="actualGalleryImage"
            width="100%"
            :height="!resMobile ? 750 : (resTablet ? 300 : 400)"
            :hide-delimiters="true"
            @change="actualGalleryThumbnails = activeThumbnailChunk"
            :show-arrows="listing.galleryImages.length > 1"
        >

            <v-carousel-item
                v-for="(image, index) in listing.galleryImages"
                :key="index"
                eager
            >
                <v-row
                    eager
                    class="fill-height"
                    align="center"
                    justify="center"
                >
                    <v-img
                        @click="openLightboxOnSlide(index+1)"
                        eager
                        width="100%"
                        :height="!resMobile ? 750 : (resTablet ? 300 : 400)"
                        :src="image.largeSize"
                        :alt="image.alternativeText"
                    ></v-img>
                </v-row>
            </v-carousel-item>
        </v-carousel>

        <v-carousel
            id="thumbnail-gallery"
            v-model="actualGalleryThumbnails"
            width="100%"
            height="75"
            hide-delimiters
            :show-arrows="listing.galleryImages.length > 8"
        >
            <v-carousel-item
                v-for="(chunk, index) in galleryChunks"
                :key="index"
            >
                <v-row
                    class="fill-height thumbnail-row"
                    :style="listing.galleryImages.length > thumbnailCount ? 'padding-right: '+thumbnailWidth : ''"
                    align-content="center"
                    justify-content="between"
                >
                    <v-col class="thumbnail" v-for="(image, i) in chunk" :key="i"
                        :style="'max-width:'+thumbnailWidth">
                        <v-img
                            width="100%"
                            height="75"
                            :src="image.mediumSize"
                            :alt="image.alternativeText"
                            :class="actualGalleryImage == index * thumbnailCount + i ? 'active' : ''"
                            @click="actualGalleryImage = index * thumbnailCount + i"
                        ></v-img>
                    </v-col>
                </v-row>
            </v-carousel-item>
        </v-carousel>

        <div class="scheme-label" v-if="listing.schemeGroup.name">
            <strong>Tenure:</strong> {{ listing.schemeGroup.name }}
        </div>
    </div>
</template>

<script>
    import { defineComponent, ref, computed, onMounted } from '@vue/composition-api'
    import isMobile from '../../composables/isMobile';
    import FsLightbox from "fslightbox-vue";

    export default defineComponent({
        props: {
            listing: {
                type: Object,
                required: true
            },
            thumbnailCount: {
                type: Number,
                default: 8
            }
        },
        components: { FsLightbox },
        setup(props, context) {
            const actualGalleryImage = ref(0);
            const actualGalleryThumbnails = ref(0);
            const lightbox = ref(false);
            const lightboxSlide = ref(1)

            // Utils
            const resMobile = computed(() => {
                //use to show carousel delimiters once instagrammable, 
                //i.e. hide-delimiters="!resMobile"
                //and remove arrows on mobile i.e. :show-arrows="!resMobile && listing.galleryImages.length > 1"
                return isMobile();
            });

            const resTablet = computed(() => {
                return isMobile(false);
            });

            const galleryChunks = computed(() => {
                return _.chunk(props.listing.galleryImages, props.thumbnailCount);
            });

            // Calculate which thumbnail set should be visible
            const activeThumbnailChunk = computed(() => {
                // Ceil will round up, so offset our value ever so slightly,
                // then reset index to 0 with -1
                return Math.ceil((actualGalleryImage.value + 0.005) / props.thumbnailCount) - 1;
            });

            const lightboxGallery = computed(() => {
                return Object.keys(props.listing.galleryImages)
                    .map(f => f = props.listing.galleryImages[f].largeSize)
            })

            const thumbnailWidth = computed(() => {
                return 100 / props.thumbnailCount + '%';
            });

            function openLightboxOnSlide(number) {
                console.log(number);
                lightboxSlide.value = number;
                lightbox.value = !this.lightbox;
            }

            return {
                actualGalleryImage,
                actualGalleryThumbnails,
                galleryChunks,
                activeThumbnailChunk,
                thumbnailWidth,
                resMobile,
                resTablet,
                lightbox,
                lightboxGallery,
                lightboxSlide,
                openLightboxOnSlide
            }
        },
    })
</script>

<style lang="scss">
    @import '~vuetify/src/styles/styles.sass';

    .carousel-container{
        position: relative;
        z-index: 9;

        .v-carousel__controls{
            bottom: 12px;

            .v-btn{
                width: 8px !important;
                height: 8px !important;

                &__content{
                    .v-icon{
                        font-size: 15px !important;
                    }
                }
            }
        }

        .scheme-label{
            position: absolute;
            top: 50px;
            right: -5px;
            padding: 6px 20px;
            box-shadow: 0px 3px 5px rgba(0,0,0,0.2);
            background: var(--v-primary-base);

            &:after{
                bottom: calc(100% - 5px);
                right: 0;
                border: solid transparent;
                content: "";
                height: 0;
                width: 0;
                position: absolute;
                pointer-events: none;
                border-color: rgba(136, 183, 213, 0);
                border-left-color: var(--v-primary-darken4);
                border-width: 5px;
                margin-right: -5px;
                z-index: -1;
            }

            @media #{map-get($display-breakpoints, 'sm-and-down')}{
                font-size: 12px;
                padding: 4px 12px;
            }
        }
    }

    #thumbnail-gallery{
        .v-window{
            &__prev{
                left: unset;
                right: 50px;
            }
        }

        .v-image{
            &:not(.v-carousel__item){
                opacity: 0.5;
                cursor: pointer;

                &.active{
                    opacity: 1;
                }
            }
        }

        @media #{map-get($display-breakpoints, 'sm-and-down')}{
            display: none !important;
        }
    }
</style>
